module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.active) ? _c('div', {
    staticClass: "event-tab"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [(_vm.extras.length > 0) ? _c('table', {
    staticClass: "table clean narrow"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.extras), function(eventComponent) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.extraName(eventComponent)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(eventComponent.quantityBooked))])])
  }), 0)]) : _c('div', {
    staticClass: "dark text-center m-3"
  }, [_vm._v("\n            No booked extras\n        ")])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Extras")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Booked")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-2b5fc476", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b5fc476"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/EventExtras.vue
// module id = 1666
// module chunks = 0